import { CashInCashOutMethod, getCashInCashOutMethodById, Merchant, MerchantData } from '@nemuru-eng/js-api-client';

import { MerchantCashInCashOutMethodEditDialog } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantCashInCashOutMethod/components/MerchantCashInCashOutMethodEditDialog';
import { MerchantCashInCashOutMethodForm } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantCashInCashOutMethod/components/MerchantCashInCashOutMethodForm';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';

interface MerchantCashInCashOutMethodProps {
  merchant: Merchant;
  merchantData?: MerchantData;
  editModeAllowed?: boolean;
}

export const MerchantCashInCashOutMethod = (props: MerchantCashInCashOutMethodProps) => {
  const id = props.merchant.cashInCashOutMethodIds?.[0];
  if (!id) {
    return <Component {...props} />;
  }
  return <WrapperWithCashInCashOutMethod id={id} {...props} />;
};

const WrapperWithCashInCashOutMethod = ({ id, ...props }: MerchantCashInCashOutMethodProps & { id: string }) => {
  const { data: cashInCashOutMethod } = useCache(
    getCashInCashOutMethodById,
    {
      id,
    },
    {
      revalidateOnMount: true,
    },
  );

  return <Component cashInCashOutMethod={cashInCashOutMethod} {...props} />;
};

const Component = ({
  cashInCashOutMethod,
  merchant,
  merchantData,
  editModeAllowed = false,
}: MerchantCashInCashOutMethodProps & {
  cashInCashOutMethod?: CashInCashOutMethod;
}) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const actionsArray: ActionsOption[] | undefined =
    editModeAllowed && merchantData
      ? [
          {
            display: (
              <Text
                tId={!merchantData.brandInformation ? 'ADD_CASH_IN_CASH_OUT_METHOD' : 'EDIT_CASH_IN_CASH_OUT_METHOD'}
              />
            ),
            onClick: toggleDialog,
            iconName: 'edit',
          },
        ]
      : undefined;

  return (
    <SubSectionWrapper title={'CASH_IN_CASH_OUT_METHOD'} specificActionsOptionsArray={actionsArray}>
      {!cashInCashOutMethod ? (
        <PendingDataWarning />
      ) : (
        <MerchantCashInCashOutMethodForm cashInCashOutMethod={cashInCashOutMethod} />
      )}
      <MerchantCashInCashOutMethodEditDialog
        opened={opened}
        setOpened={setOpened}
        toggleDialog={toggleDialog}
        merchant={merchant}
        cashInCashOutMethod={cashInCashOutMethod}
      />
    </SubSectionWrapper>
  );
};
